import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ButtonHTMLAttributes, FC } from 'react';

type ICloseButtonMobileProps = ButtonHTMLAttributes<HTMLButtonElement>;

const CloseButtonMobile: FC<ICloseButtonMobileProps> = ({ className, ...props }) => {
  return (
    <button
      {...props}
      className={cn(
        'md:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors flex items-center justify-center',
        className
      )}
    >
      <X className="w-6 h-6" />
    </button>
  );
};

export default CloseButtonMobile;
